(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["germen-article-reading"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ga-reading]').forEach((root)=>{const c=root.querySelector('[data-ga-content]'),toc=root.querySelector('[data-ga-toc]'),rail=root.querySelector('[data-ga-rail]'),details=root.querySelector('[data-ga-details]'),bar=document.querySelector('[data-ga-progress] span'),share=root.querySelector('[data-ga-share]'),grid=root.querySelector('.ga-reading__grid');if(!c)return;let intro=null,chapter=null;Array.from(c.children).forEach((n)=>{if(n.matches('h2')){chapter=document.createElement('section');chapter.className='ga-chapter ga-reveal';c.insertBefore(chapter,n);chapter.appendChild(n)}else if(chapter)chapter.appendChild(n);else{if(!intro){intro=document.createElement('div');intro.className='ga-intro ga-reveal';c.insertBefore(intro,n)}intro.appendChild(n)}});c.querySelectorAll('table').forEach((t)=>{if(t.parentElement.classList.contains('ga-table'))return;const w=document.createElement('div');w.className='ga-table';t.before(w);w.appendChild(t)});const hs=[...c.querySelectorAll('h2,h3')],ids=new Set(),slug=(s)=>s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'').slice(0,60);hs.forEach((h,i)=>{let b=h.id||`${root.dataset.sectionId}-${slug(h.textContent)||i+1}`,id=b,n=2;while(ids.has(id)||(document.getElementById(id)&&document.getElementById(id)!==h)){id=`${b}-${n++}`}ids.add(id);h.id=id;if(toc){const a=document.createElement('a');a.href=`#${id}`;a.className=h.tagName==='H3'?'h3':'';a.textContent=h.textContent;a.dataset.target=id;toc.appendChild(a)}});if(!hs.length){if(rail)rail.hidden=true;if(grid)grid.classList.add('ga-reading__grid--no-rail')}else if(grid)grid.classList.remove('ga-reading__grid--no-rail');if(details&&matchMedia('(max-width:989px)').matches)details.removeAttribute('open');const links=toc?[...toc.querySelectorAll('a')]:[];if('IntersectionObserver'in window){const o=new IntersectionObserver((es)=>{const v=es.filter(e=>e.isIntersecting)[0];if(v)links.forEach(a=>a.classList.toggle('is-active',a.dataset.target===v.target.id))},{rootMargin:'-18% 0px -70% 0px'});hs.forEach(h=>o.observe(h));if(!matchMedia('(prefers-reduced-motion:reduce)').matches){const rs=[...root.querySelectorAll('.ga-reveal')];rs.forEach(x=>x.classList.add('pending'));const ro=new IntersectionObserver((es,w)=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('visible');w.unobserve(e.target)}}),{rootMargin:'0px 0px -8% 0px'});rs.forEach(x=>ro.observe(x))}}const update=()=>{if(!bar)return;const r=c.getBoundingClientRect(),total=Math.max(1,c.offsetHeight-innerHeight*.55),now=Math.min(total,Math.max(0,innerHeight*.22-r.top));bar.style.transform=`scaleX(${now/total})`};update();addEventListener('scroll',update,{passive:true});addEventListener('resize',update);if(share)share.addEventListener('click',async()=>{const l=share.querySelector('[data-ga-share-label]'),old=l?l.textContent:'';try{if(navigator.share)await navigator.share({title:share.dataset.title,url:share.dataset.url});else if(navigator.clipboard){await navigator.clipboard.writeText(share.dataset.url);if(l){l.textContent=share.dataset.success;setTimeout(()=>l.textContent=old,1800)}}}catch(e){}})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
